// extracted by mini-css-extract-plugin
module.exports = {"jdLogin":"style_jdLogin__ovAum","header":"style_header__tIAXs","header_title":"style_header_title__mrpwJ","content":"style_content__DcCrg","loadingIcon":"style_loadingIcon__DOJ9s"};